<template>
  <div class="index container-fluid">
    <index-nav />
    <router-view></router-view>
    <index-footer />
  </div>
</template>
<script>
import indexNav from "@/components/nav";
import indexFooter from "@/components/footer";

export default {
  name: "index",
  components: {
    indexNav,
    indexFooter
  },
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.index {
  max-width: 1920px;
}
.container-fluid {
  padding: 0;
}
</style>
